/**
 * Dashboard CTA System — class names for custom buttons/links inside `.dashboard-panel`.
 * Tokens → src/styles/dashboard-cta-tokens.css
 * Colors → tailwind.config.js `theme.extend.colors` (use matching `text-*` / `bg-*` utilities).
 */

const SIZE_CLASS = {
  lg: "dashboard-cta-lg",
  md: "dashboard-cta-md",
  sm: "dashboard-cta-sm",
};

const VARIANT_CLASS = {
  primary: "dashboard-cta-primary",
  secondary: "dashboard-cta-secondary",
};

const TONE_CLASS = {
  primary: "bg-primaryblue text-white hover:bg-brightblue",
  secondary:
    "bg-white text-offblack border-mediumgray hover:border-brightblue hover:text-primaryblue",
};

export const DASHBOARD_CTA_BASE = "dashboard-cta";

export const dashboardCtaClassNames = ({
  variant = "primary",
  size = "md",
  tone,
} = {}) => {
  const resolvedTone = tone || variant;
  return [
    DASHBOARD_CTA_BASE,
    VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
    SIZE_CLASS[size] || SIZE_CLASS.md,
    TONE_CLASS[resolvedTone] || TONE_CLASS.primary,
  ]
    .join(" ")
    .trim();
};

export const DASHBOARD_CTA_CHIP_CLASS =
  "dashboard-cta-chip bg-mistygray text-offblack hover:bg-primaryblue hover:text-white";

// Full utility strings (not template literals) so Tailwind content scan includes them.
export const DASHBOARD_CTA_LINK_CLASS = [
  'dashboard-cta-link',
  'text-offblack',
  'hover:text-primaryblue',
  'active:text-primaryblue',
].join(' ');
